// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"f60e47c6","263":"767b000d","590":"c83639c8","653":"38491ad2","678":"31532a6a","929":"9c3a80cb"}[chunkId] + ".chunk.js";
};